import { Action } from '@ngrx/store';
import { Features } from '@ordersnproducts/features';

export enum FeatureToggleActionTypes {
  ENABLE_SHOW_CONTRACT = '[Order Builder Feature Toggle] Enable/hide contract input.',
}

export class EnableRMSMXContractAction implements Action {
  readonly type = FeatureToggleActionTypes.ENABLE_SHOW_CONTRACT;
  constructor(public payload: { [Features.EnableContractDetail]: boolean }) {}
}

export type FeatureToggleActions = EnableRMSMXContractAction;
